export enum TestCaseType {
  TEST_CASE = 'TEST_CASE',
  SCENARIO = 'SCENARIO'
}
